<template>
  <div class="container">
    <h2>¿Dónde deseas crear un nuevo chatbot?</h2>

    <p>
      Configura tu chatbot según el canal seleccionado. Recuerda que cada canal tiene sus propias
      configuraciones y no podrán modificarse posteriormente.
    </p>

    <div class="channel-selector">
      <ChannelCard
        v-for="channel in channels"
        :key="channel.type"
        :channel="channel"
        :selected="channel.channel === formState.selectedChannel"
        @click="handleSelect"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChannelType } from "@/app/shared/utils/enums";
import { reactive } from "vue";

import ChannelCard from "@/app/chatbots/components/cards/ChannelCard.vue";

const channels = [
  {
    type: "WhatsApp",
    title: "WhatsApp",
    description: "Incluye botones y listas.",
    hoverColor: "#F6FFED",
    channel: ChannelType.Whatsapp,
    slug: "whatsapp",
  },

  {
    type: "Messenger",
    title: "F. Messenger",
    description: "Incluye botones y tarjetas.",
    hoverColor: "#F9F0FF",
    channel: ChannelType.Messenger,
    slug: "facebook-messenger",
  },
  {
    type: "instagram",
    title: "Instagram",
    description: "Incluye botones.",
    hoverColor: "#FFF0F6",
    channel: ChannelType.Instagram,
    slug: "instragram",
  },
  {
    type: "Chat Inbound",
    title: "Webchat",
    description: "Incluye botones y tarjetas.",
    hoverColor: "#FFF2E8",
    channel: ChannelType.Inbound,
    slug: "webchat",
  },
  {
    type: "Multichannel",
    title: "Multicanal",
    description: "Para todos los canales con acciones generales. ",
    hoverColor: "#FFFBE6",
    channel: ChannelType.Multichannel,
    slug: "multicanal",
  },
];

const emit = defineEmits<{
  disable: [disabled: boolean];
  handleShowModal: [show: boolean];
}>();

const formState: { selectedChannel?: number } = reactive({ selectedChannel: undefined });

const handleSelect = (channelId: number) => {
  formState.selectedChannel = channelId;
  emit("disable", false);
  emit("handleShowModal", true);
};

const handleOk = async (value: number) => {
  return value + 1;
};

defineExpose({ handleOk, formState });
</script>

<style scoped lang="sass">
h2, p
  margin: 0

h2
  color: $gray-9
  margin-bottom: 12px
  font-size: 24px

p
  color: $gray-8
  margin-bottom: 24px
  font-size: 16px

.container
  text-align: center

.channel-selector
  display: flex
  flex-wrap: wrap
  justify-content: center
  align-items: center
  gap: 24px
</style>
